export interface VerifiedClientUser {
  id: string
  email: string
  firstName: string
  lastName: string
  userType: string
  name?: string
  planTier?: string
  dev_agent?: boolean
  roles?: string[]
  clientData: {
    accountType: string
    riskTolerance: string
    accountBalance: number
    portfolioValue: number
  }
}

export const CLIENT_AUTH_HANDOFF_TTL_MS = 30_000

let cachedClient: { user: VerifiedClientUser; verifiedAt: number } | null = null

export function cacheVerifiedClient(
  user: VerifiedClientUser,
  verifiedAt = Date.now()
): void {
  cachedClient = { user, verifiedAt }
}

export function readCachedClient(now = Date.now()): VerifiedClientUser | null {
  if (!cachedClient) return null

  const age = now - cachedClient.verifiedAt
  if (age < 0 || age > CLIENT_AUTH_HANDOFF_TTL_MS) {
    cachedClient = null
    return null
  }

  return cachedClient.user
}

export function clearCachedClient(): void {
  cachedClient = null
}